import React, { useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { Button } from '../ui/button';
import { HolidayBookingDialog } from './HolidayBookingDialog';

export const BookInstallButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button size="lg" onClick={() => setOpen(true)} className="bg-white hover:bg-gray-100 text-black font-bold" data-testid="christmas-book-date-button">
        <CalendarDays className="w-5 h-5 mr-2" />
        Book Install Date
      </Button>
      <HolidayBookingDialog open={open} onOpenChange={setOpen} />
    </>
  );
};
